import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../ResponsiveImage';
import {
  StyledHoverImageCard,
  Badge,
  ImageContainer,
  ImageInner,
  HoverImage,
  Header,
  BodyContainer,
  Body,
} from './styles.js';

export const HoverImageCard = ({
  header,
  image,
  hoverImage = null,
  body,
  badge = null,
}) => {
  return (
    <StyledHoverImageCard>
      <ImageContainer>
        <ImageInner>
          <ResponsiveImage
            alt={image.alt}
            src={image.src}
            layout="fill"
            objectFit="cover"
          />
          {hoverImage && (
            <HoverImage>
              <ResponsiveImage
                alt={hoverImage.alt}
                src={hoverImage.src}
                layout="fill"
                objectFit="cover"
              />
            </HoverImage>
          )}
          {badge && <Badge>{badge}</Badge>}
        </ImageInner>
      </ImageContainer>
      <BodyContainer>
        <Header>{header}</Header>
        {header ? ' — ' : ''}
        <Body>{body}</Body>
      </BodyContainer>
    </StyledHoverImageCard>
  );
};

HoverImageCard.displayName = 'HoverImageCard';

HoverImageCard.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  image: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  hoverImage: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
  }),
  badge: PropTypes.string,
};
